module.exports = __webpack_public_path__ + "img/cannery-4.f2472616.jpeg";